<template>
  <div class="review">
    <BaseHeader></BaseHeader>
    <div class="content">
      <div class="content-breadcrumb">作品评审</div>
      <div style="margin-top: 20px" class="divSearch">
        <el-radio-group v-model="tabRadio" size="large">
          <el-radio-button :label="item.Name" :key="item.Id" @change="radioButchange(item.Id)"
            v-for="item in matchs"></el-radio-button>
        </el-radio-group>
        <div v-show="!IsShow">
          &nbsp;&nbsp;&nbsp;&nbsp; 提交年份
          <el-select v-model="option.Model.SubmitYear" class="m-1" placeholder="请选择年份" @change="selectChange">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </div>
        <div v-show="IsShow">
          &nbsp;&nbsp;&nbsp;&nbsp; 立项年份
          <el-select v-model="option.Model.SubmitYear" class="m-1" placeholder="请选择年份" @change="selectChange">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </div>
      </div>
      <div class="table" v-show="!IsShow">
        <el-table :data="tableData.Models" style="width: 100%; text-align: center">
          <el-table-column prop="WorkId" label="编号" width="150" />
          <el-table-column label="标题" width="260">
            <template #default="scope">
              <span class="blue">{{ scope.row.Title }}</span>
            </template>
          </el-table-column>
          <el-table-column label="分类">
            <template #default="scope">
              <div v-if="['1', '2', '3', '8'].indexOf(scope.row.ForumId) > -1">
                <div>{{ scope.row.TypeName }}</div>
              </div>
              <div v-else>
                <div v-if="eduChangeApplyType.find((x) => x.value === scope.row.WorkType)">
                  {{eduChangeApplyType.find((x) => x.value === scope.row.WorkType).label}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="StatusName" label="状态">
            <template #default="scope">
              <span :class="scope.row.StatusName == '已评分' ? 'green' : ''">{{
                scope.row.StatusName
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Score" label="评分" />
          <el-table-column label="操作" width="100">
            <template #default="scope">
              <span class="cursor blue" @click="review(scope.row)" v-if="scope.row.StatusName != '已评分'">评审</span>
              <span class="cursor green" @click="show(scope.row)" v-else>查看</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="demo-pagination-block table-pagination-page" style="margin-top: 20px">
          <el-pagination v-model:currentPage="option.PageIndex" :page-sizes="[10, 20, 50, 100]"
            v-model:page-size="option.PageSize" background layout=" total,sizes, prev, pager, next, jumper"
            :total="tableData.Total" @size-change="sizeChange" @current-change="currentChange">
          </el-pagination>
        </div>
      </div>
      <div class="divReight" v-show="IsShow">
        <el-table :data="tableData.Models" style="width: 100%">
          <el-table-column prop="Leader" label="负责人" width="150" />
          <el-table-column prop="ExcelName" label="报告" width="350" />
          <el-table-column prop="SubmitYear" label="立项时间" width="180" />
          <el-table-column label="操作" width="100">
            <template #default="scope">
              <span class="cursor green" @click="clickShow(scope.row.ExcelPath)">查看报告</span>
            </template>
          </el-table-column>
        </el-table>

        <div class="demo-pagination-block table-pagination-page" style="margin-top: 20px">
          <el-pagination v-model:currentPage="option.PageIndex" :page-sizes="[10, 20, 50, 100]"
            v-model:page-size="option.PageSize" background layout=" total,sizes, prev, pager, next, jumper"
            :total="tableData.Total" @size-change="sizeChange" @current-change="currentChange">
          </el-pagination>
        </div>
      </div>
    </div>
    <ReviweEducationReformVue ref="ReviweEducationReformRef"></ReviweEducationReformVue>
  </div>
</template>
<script>
import BaseHeader from "../../views/base/BaseHeader.vue";
import { GetSoreProjectList } from "../../http/score";
import { ElMessage } from "element-plus";
import { reactive } from "@vue/reactivity";
import { GetMatchList } from "../../http/match";
import { isBlank, isImg } from "../../utils/utils";
import { ref } from "vue";
import router from "../../router";
import { GetJudgesReformSubmit } from "../../http/submit";
import { eduChangeApplyType } from "../../utils/constSetting";
import ReviweEducationReformVue from "./ReviweEducationReform.vue";
export default {
  name: "Review",
  components: {
    BaseHeader,
    ReviweEducationReformVue,
  },
  setup() {
    let IsShow = ref(false);
    let path = ref();
    const ReviweEducationReformRef = ref(null);
    const options = [
      {
        value: "2022",
        label: "2022",
      },
      {
        value: "2023",
        label: "2023",
      },
      {
        value: "2024",
        label: "2024",
      },
      {
        value: "2025",
        label: "2025",
      },
      {
        value: "2026",
        label: "2026",
      },
    ];
    let option = reactive({
      Model: {
        keywordStr: "",
        MatchId: "",
        SubmitYear: "2026",
      },
      status: ["0", "1", "2"],
      PageIndex: 1,
      PageSize: 10,
      IsAsc: false,
      SortFields: ["CreateTime"],
    });

    let tableData = reactive({
      Models: [],
      Total: 0,
    });
    let tabRadio = ref();
    let matchs = ref([]);

    let tabRadioMatchId = ref(1);
    const getMatchList = async () => {
      await GetMatchList({}).then((res) => {
        if (res.IsSuccess) {
          matchs.value = res.Models;
          if (!isBlank(matchs.value)) {
            tabRadio.value = matchs.value[0].Name;

            getSoreProjectList(matchs.value[0].Id);
          }
          matchs.value.push({
            Id: "4",
            Name: "教改中期报告",
          });
        } else {
          ElMessage.error(res.ErrorMessage);
        }
      });
    };
    getMatchList();

    const radioButchange = async (id) => {
      if (id == 4) {
        (option.Model.SubmitYear = "2022"), (IsShow.value = true);
        FormGetJudgesReformSubmit();
      } else if (id === "2") {
        option.Model.SubmitYear = "2025";
        IsShow.value = false;
        getSoreProjectList(id);
      } else {
        IsShow.value = false;
        getSoreProjectList(id);
      }
    };
    //列表
    const getSoreProjectList = async (id) => {
      option.Model.MatchId = id;
      tabRadioMatchId.value = id;
      await GetSoreProjectList(option).then((res) => {
        if (res.IsSuccess) {
          tableData.Models = res.Models;
          tableData.Total = res.TotalCount;
        } else {
          ElMessage.error(res.ErrorMessage);
        }
      });
    };

    const FormGetJudgesReformSubmit = async () => {
      GetJudgesReformSubmit(option).then((res) => {
        if (res.IsSuccess) {
          tableData.Models = res.Models;
          tableData.Total = res.TotalCount;
        } else {
          ElMessage.error(res.ErrorMessage);
        }
      });
    };

    const clickShow = (url) => {
      if (isImg(url)) {
        path.value = url;
        return;
      }
      if (
        url.indexOf(".xls") != -1 ||
        url.indexOf(".xlsx") != -1 ||
        url.indexOf(".doc") != -1 ||
        url.indexOf(".docx") != -1 ||
        url.indexOf(".pdf") != -1
      ) {
        window.open(url);
      } else {
        window.open(url);
      }
    };

    //每页的条数
    function sizeChange(val) {
      option.PageIndex = 1;
      option.PageSize = val;
      if (IsShow.value) {
        FormGetJudgesReformSubmit();
      } else {
        getSoreProjectList(tabRadioMatchId.value);
      }
    }
    //切换页数
    function currentChange(val) {
      option.PageIndex = val;
      if (IsShow.value) {
        FormGetJudgesReformSubmit();
      } else {
        getSoreProjectList(tabRadioMatchId.value);
      }
    }
    const review = (e) => {
      router.push({
        path: "/reviewScore",
        query: {
          model: encodeURIComponent(JSON.stringify(e)),
          matchId: encodeURIComponent(JSON.stringify(option.Model.MatchId)),
          submitYear: encodeURIComponent(JSON.stringify(option.Model.SubmitYear)),
        },
      });
    };
    const show = (e) => {
      router.push({
        path: "/reviewDetail",
        query: {
          model: encodeURIComponent(JSON.stringify(e)),
          matchId: encodeURIComponent(JSON.stringify(option.Model.MatchId)),
          submitYear: encodeURIComponent(JSON.stringify(option.Model.SubmitYear)),
        },
      });
    };
    const selectChange = () => {
      if (IsShow.value) {
        FormGetJudgesReformSubmit();
      } else {
        getSoreProjectList(tabRadioMatchId.value);
      }
    };
    const reviewEducationReform = (row) => {
      ReviweEducationReformRef.value.init(row.ProjectId, row.Title, row.WorkType);
    };
    return {
      show,
      review,
      tableData,
      option,
      options,
      matchs,
      tabRadio,
      tabRadioMatchId,
      getSoreProjectList,
      sizeChange,
      currentChange,
      selectChange,
      IsShow,
      FormGetJudgesReformSubmit,
      radioButchange,
      eduChangeApplyType,
      clickShow,
      path,
      ReviweEducationReformRef,
      reviewEducationReform,
    };
  },
};
</script>
<style lang="scss" scoped>
.content {
  width: 800px;
  margin: 0 auto;

  .content-breadcrumb {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #8a8a8a;
    margin-top: 20px;
  }

  .table {
    width: 100%;
    margin-top: 10px;
  }

  .blue {
    color: #409eff;
  }

  .cursor {
    cursor: pointer;
  }

  .red {
    color: red;
  }

  .green {
    color: #47b18a;
  }

  .divSearch {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
  }
}
</style>
